// extracted by mini-css-extract-plugin
export default {"list":"new-couples_list__Jn1aQ","simplebar-placeholder":"new-couples_simplebar-placeholder__pNaY2","label":"new-couples_label__ThvLQ"};